import type { Repo } from "@/types/repo";
import { Tag } from "@phosphor-icons/react";

interface Props {
  repos: Repo[];
}

export function LatestReleases({ repos }: Props) {
  const withRelease = repos.filter((r) => r.latest_release).slice(0, 6);

  if (withRelease.length === 0) return null;

  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {withRelease.map((repo) => (
        <li
          key={repo.id}
          className="eth-card flex items-center gap-3 px-4 py-3"
        >
          <Tag
            size={18}
            className="text-primary shrink-0"
            weight="duotone"
          />
          <div className="min-w-0">
            <p className="text-sm font-medium text-text-primary truncate">
              {repo.name}
            </p>
            <p className="text-xs font-code text-text-muted">
              {repo.latest_release}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
}
